import {createApp} from 'vue'
import {createPinia} from 'pinia'
import "core-js/stable";
import App from '@/console-login/App.vue'

import '@/shared/global';
import '@/console-login/global';
import '@/console-login/assets/scss/main.scss';
import sharedMixin from '@/shared/mixins';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.mixin(sharedMixin);
app.mount('#app');
